// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"598":"fe18cc86","703":"2e3aa937"}[chunkId] + ".chunk.js";
};